export type EventStatus =
  | 'NEEDS_REVIEW'
  | 'LIVE_ON_APP'
  | 'REQUIRES_EDITS'
  | 'CANCELED'
  | 'EXPIRED';

export const EVENT_STATUS_FILTERS: Record<EventStatus, string> = {
  LIVE_ON_APP: 'Live on App',
  REQUIRES_EDITS: 'Requires Edits',
  NEEDS_REVIEW: 'Needs Review',
  CANCELED: 'Canceled',
  EXPIRED: 'Expired',
};

export const EVENT_STATUS_FILTERS_ENUM: Record<EventStatus, EventStatus> = {
  NEEDS_REVIEW: 'NEEDS_REVIEW',
  LIVE_ON_APP: 'LIVE_ON_APP',
  REQUIRES_EDITS: 'REQUIRES_EDITS',
  CANCELED: 'CANCELED',
  EXPIRED: 'EXPIRED',
} as const;

export type EventDisplay = 'ALL_EVENTS' | 'UPCOMING' | 'PAST';

export const EVENT_DISPLAY_ENUM: Record<EventDisplay, EventDisplay> = {
  ALL_EVENTS: 'ALL_EVENTS',
  UPCOMING: 'UPCOMING',
  PAST: 'PAST',
} as const;

export const EVENT_DISPLAY_FILTERS: Record<EventDisplay, string> = {
  ALL_EVENTS: 'View All Events',
  UPCOMING: 'Upcoming Events',
  PAST: 'Past Events',
};

// Event Request Filters
export type EventRequestFilter = 'APPROVED' | 'DENIED' | 'NO_ACTION';

export const EVENT_REQUEST_FILTERS: Record<EventRequestFilter, string> = {
  APPROVED: 'Approved by me',
  DENIED: 'Denied by me',
  NO_ACTION: 'No Action taken',
};

export const EVENT_REQUEST_FILTERS_ENUM: Record<EventRequestFilter, EventRequestFilter> = {
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  NO_ACTION: 'NO_ACTION',
} as const;

// Event Request Display Filters (Tabs)
export type EventRequestDisplayFilter = 'ALL' | 'NEEDS_APPROVAL' | 'TRACKER';

export const EVENT_REQUEST_DISPLAY_FILTERS: Record<EventRequestDisplayFilter, string> = {
  NEEDS_APPROVAL: 'Needs My Review',
  ALL: 'All Events',
  TRACKER: 'Event Tracker',
};

export const EVENT_REQUEST_DISPLAY_FILTERS_ENUM: Record<EventRequestDisplayFilter, EventRequestDisplayFilter> = {
  ALL: 'ALL',
  NEEDS_APPROVAL: 'NEEDS_APPROVAL',
  TRACKER: 'TRACKER',
} as const;
